export default "__VITE_ASSET__01fd2ae1__"